import { render, staticRenderFns } from "./SelectProject.vue?vue&type=template&id=32a08030&"
import script from "./SelectProject.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SelectProject.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports